/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/095-box-add': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13 1H3L0 4v10.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V4l-3-3zM8 13L3 9h3V6h4v3h3l-5 4zM2.414 3l1-1h9.172l1 1H2.414z"/>'
  }
})
